import moment from "moment";
import React from "react";
import { RenderKilogramo } from "../../../../../Utils/renderField/renderReadField";

export const IngresosSobranteReprocesoTable = ({ ingresosSobrante = [] }) => {
    const total_kg_secos_lab = ingresosSobrante.reduce(
        (total, item) => total + Number(item.kg_secos_lab || 0),
        0,
    );
    const total_kg_secos_liq = ingresosSobrante.reduce(
        (total, item) => total + Number(item.kg_secos_liq || 0),
        0,
    );

    return (
        <div className="new-table-wrapper ingresos-almacen__table-wrapper">
            <table className="table-striped">
                <thead>
                    <tr>
                        <th>Salida bodega</th>
                        <th>Fecha ingreso</th>
                        <th>Producto</th>
                        <th>Conforme</th>
                        <th>Kg secos laboratorio</th>
                        <th>Kg secos liquidación</th>
                    </tr>
                </thead>
                <tbody>
                    {ingresosSobrante.length === 0 && (
                        <tr>
                            <td colSpan={6} className="text-center">
                                No hay sobrantes enviados disponibles.
                            </td>
                        </tr>
                    )}
                    {ingresosSobrante.map((item) => {
                        return (
                            <tr key={item.detalle_salida_id}>
                                <td className="text-center text-nowrap">
                                    {item.numero_salida}
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.fecha_ingreso
                                        ? moment(item.fecha_ingreso).format(
                                              "DD/MM/YYYY",
                                          )
                                        : "N/A"}
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.producto || "N/A"}
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.es_conforme_bodega
                                        ? "Conforme"
                                        : "No conforme"}
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.kg_secos_lab ? (
                                        <RenderKilogramo
                                            value={item.kg_secos_lab}
                                            decimalScale={3}
                                        />
                                    ) : (
                                        "—"
                                    )}
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.kg_secos_liq ? (
                                        <RenderKilogramo
                                            value={item.kg_secos_liq}
                                            decimalScale={3}
                                        />
                                    ) : (
                                        "—"
                                    )}
                                </td>
                            </tr>
                        );
                    })}
                    <tr className="totales-row">
                        <td
                            colSpan={4}
                            className="text-right font-weight-bold"
                        >
                            Total:
                        </td>
                        <td className="text-center text-nowrap font-weight-bold">
                            <RenderKilogramo
                                value={total_kg_secos_lab}
                                decimalScale={3}
                            />
                        </td>
                        <td className="text-center text-nowrap font-weight-bold">
                            <RenderKilogramo
                                value={total_kg_secos_liq}
                                decimalScale={3}
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};
